import { Button, styled } from '@chakra-ui/react';

export const PrimaryButton = styled(Button, {
  baseStyle: {
    size: 'sm',
    px: 6,
    fontWeight: 600,
    bg: 'blue.500',
    color: 'white',
    borderRadius: 'full',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.2s ease-in-out',
    _hover: {
      bg: 'blue.600',
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
    },
    _active: {
      transform: 'translateY(0)',
    },
  },
});

export const SecondaryButton = styled(Button, {
  baseStyle: {
    size: 'sm',
    px: '10px',
    fontWeight: 500,
    bg: 'transparent',
    border: '1px solid',
    borderColor: 'gray.300',
    color: 'gray.700',

    _hover: {
      bg: 'gray.50',
    },
  },
});

export const DangerButton = styled(Button, {
  baseStyle: {
    size: 'sm',
    px: 4,
    py: 2,
    fontWeight: 500,
    bg: 'transparent',
    border: '1px solid',
    borderColor: 'red.500',
    color: 'red.500',

    _hover: {
      bg: 'red.50',
    },
  },
});

export const SmallButton = styled(Button, {
  baseStyle: {
    size: 'xs',
    px: 3,
    fontWeight: 500,
  },
});
